import { Component } from '@angular/core';

@Component({
  selector: 'app-rolling-commission',
  templateUrl: './rolling-commission.component.html',
  styleUrls: ['./rolling-commission.component.scss']
})
export class RollingCommissionComponent {

}
